var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-template',{attrs:{"title":_vm.$t('title'),"description":_vm.$t('description'),"imageUrl":require(`@/assets/recipients-biometry/approved.svg`).default}})
}
var staticRenderFns = []

export { render, staticRenderFns }